// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TrademarkCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/TrademarkCircleTwoTone";
import AntdIcon from '../components/AntdIcon';

var TrademarkCircleTwoTone = function TrademarkCircleTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TrademarkCircleTwoToneSvg
  }));
};

TrademarkCircleTwoTone.displayName = 'TrademarkCircleTwoTone';
export default React.forwardRef(TrademarkCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/TrademarkCircleTwoTone.js
// module id = 1951
// module chunks = 0